'use client';
import React, { useEffect, useState } from 'react';
import MoonClearLineIcon from 'remixicon-react/MoonClearLineIcon';
import SunLineIcon from 'remixicon-react/SunLineIcon';
import { useTheme } from 'next-themes';

interface ModeToggleProps {
    className?: string;
}

export function ModeToggle({ className }: ModeToggleProps) {
    const { setTheme, resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);
    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const toggleTheme = () => {
        setToggled(true);
        const newTheme = resolvedTheme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    };

    if (!mounted) {
        return (
            <button
                type='button'
                className={`flex items-center justify-center size-7 rounded-full border-0 !shadow-none shrink-0 ${className || ''}`}
            >
                <MoonClearLineIcon size={18} className='invisible' />
            </button>
        );
    }

    const isDark = resolvedTheme === 'dark';
    // The current icon turns 30° left and fades, the other comes in from 30° right (keyframes in
    // globals.css). Keyframes, not transitions: the theme provider disables every CSS transition
    // for a moment while the theme changes (disableTransitionOnChange), which cut a
    // transition-based swap. Only after a click, so nothing animates on page load.
    const icon = 'theme-icon absolute inset-0 flex items-center justify-center';
    const state = (visible: boolean) =>
        toggled ? (visible ? 'theme-icon-in' : 'theme-icon-out') : visible ? '' : 'opacity-0';
    return (
        <button
            type='button'
            // min-w: the icons are stacked absolutely, so a caller's w-fit would collapse it to 0
            className={`relative flex items-center justify-center size-7 min-w-7 rounded-full border-0 !shadow-none text-zinc-700 dark:text-white hover:text-progress dark:hover:text-progress transition-colors shrink-0 ${className || ''}`}
            onClick={toggleTheme}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
            <span aria-hidden className={`${icon} ${state(isDark)}`}>
                <MoonClearLineIcon size={18} />
            </span>
            <span aria-hidden className={`${icon} ${state(!isDark)}`}>
                <SunLineIcon size={18} />
            </span>
        </button>
    );
}
